
import { getSliceComponentProps } from '@prismicio/vue/components'

export default {
  name: 'FeatureBannerWide',
  // The array passed to `getSliceComponentProps` is purely optional and acts as a visual hint for you
  props: getSliceComponentProps(['slice', 'index', 'slices', 'context']),
}
